import React, { useEffect, useRef } from 'react';
import { Link, Typography, Box, useMediaQuery } from '@mui/material';
import NoEncryption from '@mui/icons-material/NoEncryption';

interface HttpWarningProps {
  onHeightChange?: (height: number) => void;
}

export const HttpWarning: React.FC<HttpWarningProps> = ({ onHeightChange }) => {
  const isHttp = window.location.protocol === 'http:';
  if (!isHttp) return null;

  const isMobile = useMediaQuery('(max-width:440px)');
  const msg =
    'Aviso: você está acessando este portal através do protocolo HTTP, portanto, algumas funcionalidades podem não estar disponíveis devido a bloqueios de segurança do seu próprio navegador. Para maior segurança e evitar acessos indevidos é importante que utilizem o protocolo HTTPS. Contate sua equipe de internet para realizar esta ação, mais informações ';

  const warningRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (onHeightChange && warningRef.current) {
      onHeightChange(warningRef.current.offsetHeight);
    }
  }, [onHeightChange]);

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          margin: '10px',
          padding: isMobile ? '5px' : '15px',
          backgroundColor: '#f2dede',
          border: '1px solid #ebccd1',
          borderRadius: '4px',
          zIndex: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: isMobile ? '12px' : '14px' }}
        >
          <NoEncryption
            sx={{
              fontSize: isMobile ? '12px' : 'medium',
              margin: isMobile ? '0 2px 3px 0' : '0 5px 5px 0',
              verticalAlign: 'middle',
            }}
          />
          <span style={{ color: '#a94442' }}>{msg}</span>
          <Link
            href="https://www.cigam.com.br/wiki/index.php?title=GE_-_Importância_do_uso_do_HTTPS"
            target="_blank"
          >
            aqui.
          </Link>
        </Typography>
      </Box>
    </>
  );
};
